export enum TricServiceCode {
    COLD_WATER_10 = "s10",
    COLD_WATER_55 = "s55",
    COLD_WATER_72 = "s72",
    COLD_WATER_703 = "s703",
    HOT_WATER_8 = "s8",
    HOT_WATER_249 = "s249",
    ELECTRICITY = "m1",
    HEATING = "s11"     // Центральное отопление (разные единицы измерения)
}

export type ServiceUnit = {
    unit: string;
    maxConsumption: number;
}


export enum TricServiceNameByCode {
    s10 = 'Холодная вода',
    s55 = 'Холодная вода',
    s72 = 'Холодная вода',
    s703 = 'Холодная вода',
    s8 = 'Горячая вода',
    s249 = 'Горячая вода',
    m1 = 'Электричество',
    s11 = 'Центральное отопление'
}

export type TricSource = 'itpc' | 'vostok';

export type Readings = {
    previous: string;
    current: string;
    date: Date;
}

export type TricMeter = {
    id: number;
    serial: string;
    model: string;
    place: string;
    readings: Readings;
    next_verification_date: Date;
    source: TricSource;
    service: string;
    unit: string;
}

export type TricGroup = {
    service: TricServiceCode;
    name: string;
    counter: TricMeter[];
}

export type MeterTricResponse = {
    account: number;
    address: string;
    groups: TricGroup[];
}

export type CreateMeterEntriesRequest = Record<TricServiceCode, { id: number; value: string }[]>;

export type CreateMeterEntriesResponse = {
    [key in TricServiceCode]?: {
        apply: boolean;
        status: string;
    };
}[];

// vostok-asrn
// 9mvwrh-FfSMvAp45

export interface TricAccount {
    city: string;
    street: string;
    number: number;
    housing: string;
    letter: string;
    flat_number: number;
    flat_corpus: string;
    flat_literal: string;
    flat_id: number;
    full_address: string;
}

export type TricFlat = {
    city: number;
    street: number;
    house: number;
    flat: number;
    id_type: number;
    type: string;
}